// configuration for static site

import { YCBConfigArray } from 'Config/types';

import { DEFAULT_LANGUAGE } from 'Store/internationalization/constants';

import { getImageByVariant } from 'Assets/images/download';

export type StaticSiteConfig = {
  downloadPage: {
    image: string;
  };
};

const staticSite: YCBConfigArray<StaticSiteConfig> = [
  {
    settings: ['main'] as const,
    downloadPage: {
      image: getImageByVariant(DEFAULT_LANGUAGE),
    },
  },
];

export default staticSite;
